import select from 'select';

export const clipboard = {
  copy: (
    element: Element,
  ) => {
    const text = select(element);
    return new Promise<void>((resolve) => {
      try {
        return navigator.clipboard.writeText(text);
      } catch (error) {
        document.execCommand('copy');
      }
      return resolve();
    });
  },
};
